export const formatPrice = (price) => {
    if (price) {
        if (price > 0) {
            return `+${price?.toFixed(0)}`;
        } else {
            return `${price?.toFixed(0)}`
        }
    } else {
        return ''
    }
    
}